/**
 * Decor spot rectangles from @mp/art (`decorSpotLayout`, next to the upgrade slots), loaded
 * lazily through the same chunk as shopLayout.ts and normalised to the shop base image the same
 * way: x/y = top-left, w/h = size fractions. Without the art module there are no spots, so the
 * shop offers no Decorate mode and shows no decor, rather than guessing positions.
 */
import type { Placement } from './shopLayout.js';

type ArtModule = {
  decorSpotLayout?: Record<string, { x: number; y: number; w: number; h: number; z: number }>;
  SHOP_CANVAS?: { w: number; h: number };
};

const artModule = import.meta.glob<ArtModule>('../../../../packages/art/src/index.ts');

export async function decorSpotLookup(): Promise<Record<string, Placement>> {
  const loader = Object.values(artModule)[0];
  const m: ArtModule = loader ? await loader().catch(() => ({})) : {};
  const canvas = m.SHOP_CANVAS ?? { w: 1024, h: 768 };
  return Object.fromEntries(
    Object.entries(m.decorSpotLayout ?? {}).map(([spot, r]) => [spot, { x: r.x / canvas.w, y: r.y / canvas.h, w: r.w / canvas.w, h: r.h / canvas.h, z: r.z }]),
  );
}
